﻿'use strict';

angular.module('ntmApp').factory('UnderAllocatedStaffFilter', ['MultiSelectFilter', 'WeeklyHoursFilter', 'Constants', 'Utils', function (MultiSelectFilter, WeeklyHoursFilter, Constants, Utils) {

    function UnderAllocatedStaffFilter() {

        var self = this;

        self.RoleFilter = new MultiSelectFilter(Constants.DropDownBlankLabels.NoRole);
        self.WeeklyAvailableHoursFilter = new WeeklyHoursFilter('Available {0} {1} hours');

        self.getfilters = function () {
            return [
                self.RoleFilter,
                self.WeeklyAvailableHoursFilter
            ];
        };

        self.getAppliedFilters = function () {
            return self.getfilters().filter(function (filter) {
                return filter.isDefined();
            });
        };

        self.applied = function () {
            var filters = self.getAppliedFilters();

            if (filters) {
                return filters.length > 0;
            }

            return false;
        };

        self.isPartlyDefined = function () {
            return self.getfilters().some(function(filter) { return filter.isPartlyDefined(); });
        };

        self.clearAllFilters = function () {
            self.getfilters().forEach(function (filter) {
                filter.clear();
            });
        };

        self.performFiltering = function (staffItems) {
            
            var result = [];

            staffItems.forEach(function (staffItem) {

                if (self.selectedStaff && self.selectedStaff.id) {

                    if (staffItem.personId !== self.selectedStaff.id) {
                        return;
                    }
                }

                if (self.RoleFilter.isDefined() && !self.RoleFilter.selectedItems.some(function (role) {
                        return (role.id === staffItem.personRole) || (!role.id && !staffItem.personRole);
                })) {
                    return;
                }


                if (!isStaffDayApplied(staffItem)) {
                    return;
                }

                result.push(staffItem);

            });


            return result;

        };

        function isStaffDayApplied(staffItem) {

            if (self.WeeklyAvailableHoursFilter.isDefined()) {

                var findStaffDayItem = function (staffDOWItem) {
                    var date = new moment(staffDOWItem.date);
                    var dayOfWeek = date.day();
                    return dayOfWeek === selectedDay.dayOfWeek;
                };

                for (var i = 0; i < self.WeeklyAvailableHoursFilter.selectedDays.length; i++) {

                    var selectedDay = self.WeeklyAvailableHoursFilter.selectedDays[i];
                    var staffItemOfDay = staffItem.staffDays.firstOrDefault(findStaffDayItem);

                    if (staffItemOfDay) {

                        if (Constants.StaffAttendTypes.isStaffPresent(staffItemOfDay.attendString)) {

                            var availableHours = Utils.MinutesToHours(staffItemOfDay.available, 2);
                            var result = self.WeeklyAvailableHoursFilter.hoursComparator === '>=' ? parseFloat(availableHours) >= self.WeeklyAvailableHoursFilter.hours :
                                                                                                    parseFloat(availableHours) <= self.WeeklyAvailableHoursFilter.hours;

                            if (!result) {
                                return false;
                            }

                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                }
            }

            return true;
        }
    }

    return (UnderAllocatedStaffFilter);
}]);